import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as moment from "moment";
import { NotifyService } from "../services/notify-service";
import { ReportService } from "../services/report-service";
import { EntityConfigService } from "../services/entity-config-service";
import { EntityService } from "../services/entity-service";
import { DateLocaleService } from "../services/date-locale-service";
import { AclService } from "../services/acl-service";
import { LocalCacheService } from "../services/local-cache-service";
import { RightsFilterService } from "assets/app/services/rights-filter-service";

export function RLRightsFilter() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/rights-filter.html"),
        require: "rlRightsFilter",
        controller: RLRightsFilterController,
        controllerAs: "rfVM",
        bindToController: true,
        scope: {
            filterModel: "=",
            searchMethod: "&",
            clearMethod: "&",
            mode: "=",
            hideSearch: "@",
            parentEntityCharTypeID: "=?parentEntityCharTypeId"
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLRightsFilterController) => {

        }
    };
    return directive;
}

class RLRightsFilterController {
    static $inject = ["$scope", "$q", "notifyService", "reportService", "entityConfigService", "entityService", "dateLocaleService", "aclService", "rightsFilterService"];

    mode: number;

    showDates: boolean;
    showTemplates: boolean;
    showStatuses: boolean;
    showAssetSearch: boolean;
    showFacets: boolean;
    showRightTypes: boolean;
    showFlexibleExclusive: boolean;
    showExclusive: boolean;
    showDimensions: boolean;
    showShowLabels: boolean;
    showTitleKeywords: boolean;
    showAssetChars: boolean;
    showFlexible: boolean;
    showFacetSelects: boolean;
    showWindowOptions: boolean;
    showWindowTruncateOption: boolean;
    showWindowed: boolean;
    showAvailability: boolean;
    showScoped: boolean;
    showRollup: boolean;
    showDimFormat: boolean;
    direction: number;

    filterModel: Models.IRightsFilterModel;

    assetSearchModalOpen: boolean;                              // asset search modal open
    selectedAssetIDs: { [key: number]: boolean };               // selected assetIDs
    selectedAssetDocsSorted: Models.IEntitySearchDoc[];         // above sorted
    selectedAssetTitles: string[];                              // above titles (for display)

    dateBtnText: string;                                        // description of date range

    assetFacetFields: Models.IDictionaryS<string>;                // dictionary of facets by [key]:[pretty name]
    assetFacetResults: Models.IFacetResults;                    // facet values

    rightSetTemplates: Models.ICharacteristicTemplate[];        // list of rightset templates
    rightSetStatuses: Models.IEntityStatus[];                   // list of rightset statuses for selectedTemplateID
    selectedTemplateLabel: string;                              // name of selected Template
    selectedStatusLabel: string;                                // name of selected status

    exclusive: string;                                          // exclusibity
    exactInd: string;                                           // flexibility

    boolToString = (value: boolean) => value ? "1" : "0";
    stringToBool = (value: string) => value == "1";
    tristateToString = (value: boolean) => value == null ? "" : (value === true ? "1" : "0");
    stringToTristate = (value: string) => value == "1" ? true : (value == "0" ? false : null);

    numberToString = (value: number) => value != null ? value.toString() : "";
    stringToNumber = (value: string) => _.isEmpty(value) ? null : _.parseInt(value);
    parentEntityCharTypeID: number;

    public get isAssetAvailable(): string {
        return this.boolToString(this.filterModel.isAssetAvailable);
    };

    public set isAssetAvailable(value: string) {
        this.filterModel.isAssetAvailable = this.stringToBool(value);
    };

    public get isTupleAvailable(): string {
        return this.tristateToString(this.filterModel.isTupleAvailable);
    };

    public set isTupleAvailable(value: string) {
        this.filterModel.isTupleAvailable = this.stringToTristate(value);
    };

    public get isScoped(): string {
        return this.boolToString(this.filterModel.isScoped);
    };

    public set isScoped(value: string) {
        this.filterModel.isScoped = this.stringToBool(value);
    };

    public get rollupDim(): number {
        return this.filterModel.rollupDim;
    }

    public set rollupDim(value: number) {
        this.filterModel.rollupDim = value;
    }

    dimensions: { key: number; value: string }[];

    territoryLovs: Models.ICharacteristicMetaDataValue[];       // territory LOVs
    mediaLovs: Models.ICharacteristicMetaDataValue[];           // media LOVs
    channelLovs: Models.ICharacteristicMetaDataValue[];         // channel LOVs
    languageLovs: Models.ICharacteristicMetaDataValue[];        // language LOVs

    selectedTerritoryIDs: number[];                                 // selected territory IDs
    selectedTerritoryLovs: Models.ICharacteristicMetaDataValue[];   // selected territory LOVs
    selectedTerritoryLabels: string[];                              // selected territory Labels (for display)
    selectedMediaIDs: number[];                                 // selected media IDs
    selectedMediaLovs: Models.ICharacteristicMetaDataValue[];   // selected media LOVs
    selectedMediaLabels: string[];                              // selected media Labels (for display)

    selectedChannelIDs: number[];                                   // selected channel IDs
    selectedChannelLovs: Models.ICharacteristicMetaDataValue[];     // selected channel LOVs
    selectedChannelLabels: string[];                                // selected channel Labels (for display)
    selectedLanguageIDs: number[];                                  // selected language IDs
    selectedLanguageLovs: Models.ICharacteristicMetaDataValue[];    // selected language LOVs
    selectedLanguageLabels: string[];                               // selected language Labels (for display)

    // groups
    languageGroups: Models.ICharacteristicValueGroup[];
    selectedLanguageGroup: Models.ICharacteristicValueGroup;
    listOfLanguages: Models.ICharacteristicMetaDataValue[];
    languageTagLabel: string;
    languageCharLabel: string;

    territoryGroups: Models.ICharacteristicValueGroup[];
    selectedTerritoryGroup: Models.ICharacteristicValueGroup;
    listOfTerritories: Models.ICharacteristicMetaDataValue[];
    territoryTagLabel: string;
    territoryCharLabel: string;

    mediaGroups: Models.ICharacteristicValueGroup[];
    selectedMediaGroup: Models.ICharacteristicValueGroup;
    listOfMedias: Models.ICharacteristicMetaDataValue[];
    mediaTagLabel: string;
    mediaCharLabel: string;

    channelGroups: Models.ICharacteristicValueGroup[];
    selectedChannelGroup: Models.ICharacteristicValueGroup;
    listOfChannels: Models.ICharacteristicMetaDataValue[];
    channelTagLabel: string;
    channelCharLabel: string;

    assetCharacteristics: Models.ICharacteristic[];
    assetCharacteristicLovs: Models.ICharacteristicMetaDataValue[];
    assetCharLabel: string;
    selectAllAssetCharLovs: boolean;
    selectedAssetCharLabels: string[];

    filterInitialized: boolean;

    searchMethod: () => any;
    clearMethod: () => any;
    hideSearch: boolean;

    allowMultiple: boolean;
    showColumns: string[];
    canCreate: string;
    showAdvance: boolean;
    selectedRecordIds: number[];
    selectedCharTypeID: number;
    selectedAssetTemplateID: number;
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
    selectedRecIDTitlePairsSorted: Models.IKeyValuePair<number, string>[];          // above sorted
    allSelected: {
        [facetKey: string]: boolean
    };
    toggleSelectedAssetFacetValue: {
        [facetKey: string]: boolean
    };

    matchTypes: Models.IKeyValuePair<number, string>[];


    get datesValid(): boolean {
        var startMoment = this.dateLocaleService.parseMoment(this.filterModel.startDate);
        var endMoment = this.dateLocaleService.parseMoment(this.filterModel.endDate);
        if (startMoment.isValid() && endMoment.isValid()) {
            return endMoment.isAfter(startMoment);
        } else {
            return true;
        }
    }

    get valid(): boolean {
        return this.datesValid;
    }

    constructor(private $scope: ng.IScope,
        private $q: ng.IQService,
        private notifyService: NotifyService,
        private reportService: ReportService,
        private entityConfigService: EntityConfigService,
        private entityService: EntityService,
        private dateLocaleService: DateLocaleService,
        private aclService: AclService,
        private rightsFilterService: RightsFilterService) {

    }

    $onInit() {
        this.hideSearch = false;
        this.showAssetSearch = this.showDates = this.showDimensions
            = this.showExclusive = this.showFacets = this.showFlexibleExclusive
            = this.showRightTypes = this.showShowLabels = this.showStatuses = this.showTemplates
            = this.showTitleKeywords = this.showAssetChars = this.showFlexible = this.showFacetSelects
            = this.showWindowOptions = this.showAvailability = this.showScoped = this.showRollup
            = this.showWindowed = this.showWindowTruncateOption = this.showDimFormat = false;


        switch (this.mode) {
            case 0:
                this.showDates = true;
                this.showTemplates = false;
                this.showStatuses = false;
                this.showAssetSearch = true;
                this.showFacets = true;
                this.showFacetSelects = false;
                this.showRightTypes = true;
                this.showFlexibleExclusive = true;
                this.showExclusive = false;
                this.showFlexible = false;
                this.showDimensions = true;
                this.showShowLabels = true;
                this.showTitleKeywords = false;
                this.showAssetChars = false;
                this.showWindowOptions = true;
                this.showWindowed = true;
                break;
            case 1:
                this.showDates = true;
                this.showTemplates = false;
                this.showStatuses = false;
                this.showAssetSearch = true;
                this.showFacets = true;
                this.showFacetSelects = false;
                this.showRightTypes = false;
                this.showFlexibleExclusive = true;
                this.showExclusive = false;
                this.showFlexible = false;
                this.showDimensions = true;
                this.showShowLabels = false;
                this.showTitleKeywords = false;
                this.showAssetChars = false;
                this.showWindowOptions = true;
                this.showRollup = true;
                this.showWindowed = true;
                this.showWindowTruncateOption = true;
                this.showDimFormat = true;
                break;
            case 2:
                this.showDates = true;
                this.showTemplates = true;
                this.showStatuses = true;
                this.showAssetSearch = false;
                this.showFacets = false;
                this.showFacetSelects = false;
                this.showRightTypes = false;
                this.showFlexibleExclusive = false;
                this.showExclusive = true;
                this.showFlexible = false;
                this.showDimensions = true;
                this.showShowLabels = false;
                this.showTitleKeywords = this.parentEntityCharTypeID == 1 ? false : true;
                this.showAssetChars = false;
                break;
            case 3:
                this.showDates = true;
                this.showTemplates = false;
                this.showStatuses = false;
                this.showAssetSearch = false;
                this.showFacets = false;
                this.showFacetSelects = false;
                this.showRightTypes = false;
                this.showFlexibleExclusive = false;
                this.showExclusive = true;
                this.showFlexible = false;
                this.showDimensions = true;
                this.showShowLabels = false;
                this.showTitleKeywords = false;
                this.showAssetChars = true;
                break;
            case 4:
                this.showDates = true;
                this.showTemplates = false;
                this.showStatuses = false;
                this.showAssetSearch = false;
                this.showFacets = false;
                this.showFacetSelects = true;
                this.showRightTypes = false;
                this.showFlexibleExclusive = false;
                this.showFlexible = true;
                this.showExclusive = false;
                this.showDimensions = true;
                this.showShowLabels = false;
                this.showTitleKeywords = true;
                this.showAssetChars = false;
                break;
            case 5:
                this.showDates = true;
                this.showTemplates = false;
                this.showStatuses = false;
                this.showAssetSearch = false;
                this.showFacets = false;
                this.showFacetSelects = true;
                this.showRightTypes = false;
                this.showFlexibleExclusive = false;
                this.showFlexible = true;
                this.showExclusive = false;
                this.showDimensions = true;
                this.showShowLabels = false;
                this.showTitleKeywords = true;
                this.showAssetChars = false;
                break;
            default:
                break;
        }


        this.assetSearchModalOpen = false;
        this.selectedAssetIDs = {};
        this.selectedAssetTitles = [];
        this.selectedAssetDocsSorted = [];
        this.direction = 0;

        this.dateBtnText = "";

        this.allowMultiple = true;
        this.showColumns = [];
        this.canCreate = "false";
        this.showAdvance = true;
        this.selectedRecordIds = [];
        this.selectedCharTypeID = Consts.CharTypeIDs.property;
        this.selectedAssetTemplateID = 0;
        this.selectedRecIdTitlePairs = [];
        this.selectedRecIDTitlePairsSorted = [];
        this.allSelected = {};
        this.toggleSelectedAssetFacetValue = {};

        // hardcoded facet set
        this.assetFacetFields = {
            "release_year_int": "Release Year",
            "genre_metas": "Genre",
            "mpaa_rating_meta": "Rating",
            "run_status_str": "Run Status",
            "template_meta": "Catalog Type",
            "status_meta": "Status"
        };

        switch (this.mode) {
            case 4:
            case 5:
                this.assetFacetFields = {
                    "genre_metas": "Genre",
                    "template_meta": "Template",
                    "status_meta": "Status"
                };
                break;
            default:
                break;
        }

        this.assetFacetResults = {};

        this.rightSetTemplates = [];
        this.rightSetStatuses = [];
        this.selectedTemplateLabel = "";
        this.selectedStatusLabel = "";

        this.territoryLovs = [];
        this.mediaLovs = [];
        this.channelLovs = [];
        this.languageLovs = [];

        this.selectedTerritoryIDs = [];
        this.selectedTerritoryLovs = [];
        this.selectedTerritoryLabels = [];
        this.selectedMediaIDs = [];
        this.selectedMediaLovs = [];
        this.selectedMediaLabels = [];
        this.selectedChannelIDs = [];
        this.selectedChannelLovs = [];
        this.selectedChannelLabels = [];
        this.selectedLanguageIDs = [];
        this.selectedLanguageLovs = [];
        this.selectedLanguageLabels = [];

        this.assetCharacteristics = [];
        this.assetCharacteristicLovs = [];
        this.assetCharLabel = "";
        this.selectAllAssetCharLovs = false;
        this.selectedAssetCharLabels = [];

        this.filterInitialized = false;

        this.dimensions = [];

        this.matchTypes = [
            { key: 0, value: "Cover Entire Search Range" },
            { key: 1, value: "Overlap Part of Search Range" },
            { key: 2, value: "Start within Search Range" },
            { key: 3, value: "End within Search Range" },
        ];

        // update date range description when dates change
        this.$scope.$watchCollection<[string, string]>(() => <[string, string]>[this.filterModel.startDate, this.filterModel.endDate],
            (newValue, oldValue) => {
                var startMoment = this.dateLocaleService.parseMoment(newValue[0]);
                var endMoment = this.dateLocaleService.parseMoment(newValue[1]);
                if (startMoment.isValid() && endMoment.isValid()) {
                    this.dateBtnText = startMoment.format("L") + " to " + endMoment.format("L");
                }
                else if (this.mode == 2) {
                    if (startMoment.isValid() && !endMoment.isValid()) {
                        this.dateBtnText = startMoment.format("L") + " and later";
                    }
                    else if (!startMoment.isValid() && endMoment.isValid()) {
                        this.dateBtnText = endMoment.format("L") + " and earlier";
                    } else {
                        this.dateBtnText = null;
                    }
                }
                else {
                    this.dateBtnText = null;
                }

            });

        // get labels from selected territories
        this.$scope.$watchCollection(() => this.selectedTerritoryLovs,
            (newValue) => {
                this.selectedTerritoryLabels = newValue.map((lov) => lov.characteristicValueLabel);
            });

        // get labels from selected medias
        this.$scope.$watchCollection(() => this.selectedMediaLovs,
            (newValue) => {
                this.selectedMediaLabels = newValue.map((lov) => lov.characteristicValueLabel);
            });

        // get labels from selected channels
        this.$scope.$watchCollection(() => this.selectedChannelLovs,
            (newValue) => {
                this.selectedChannelLabels = newValue.map((lov) => lov.characteristicValueLabel);
            });

        // get labels from selected languages
        this.$scope.$watchCollection(() => this.selectedLanguageLovs,
            (newValue) => {
                this.selectedLanguageLabels = newValue.map((lov) => lov.characteristicValueLabel);
            });

        // update the status values when a non-null templateID is selected
        this.$scope.$watch(() => this.filterModel.selectedTemplateID,
            (newValue, oldValue) => {
                if (newValue != oldValue && this.showStatuses) {

                    var template = _.find(this.rightSetTemplates, (template) => template.templateID == newValue);
                    this.selectedTemplateLabel = template != null ? template.templateName : "";

                    this.filterModel.selectedStatusID = null;
                    if (newValue != null) {
                        this.notifyService.startProgress();
                        this.entityConfigService.getTemplateStatuses(Consts.CharTypeIDs.right, newValue)
                            .then((results) => {
                                this.rightSetStatuses = results;
                            })
                            .finally(() => {
                                this.notifyService.endProgress();
                            });
                    } else {
                        this.rightSetStatuses = [];
                    }
                }
            });

        this.$scope.$watch(() => this.filterModel.selectedStatusID,
            (newValue, oldValue) => {
                if (newValue != oldValue && this.showStatuses) {
                    var status = _.find(this.rightSetStatuses, (status) => status.stepID == newValue);
                    this.selectedStatusLabel = status != null ? status.stepName : "";
                }
            });

        this.$scope.$watch(() => this.filterModel.assetCharID,
            (newValue, oldValue) => {
                var assetChar = _.find(this.assetCharacteristics, (ch) => ch.characteristicID == this.filterModel.assetCharID);
                this.assetCharLabel = assetChar != null ? assetChar.label : "";
                if (newValue != null && newValue != oldValue) {
                    this.filterModel.selectedAssetCharValueIDs = [];
                    this.notifyService.startProgress();
                    this.entityConfigService.getLovList(Consts.CharTypeIDs.property, newValue, null)
                        .then((result) => {
                            this.assetCharacteristicLovs = result;
                            this.selectAllAssetCharLovs = true;
                        })
                        .finally(() => {
                            this.notifyService.endProgress();
                        });
                }
            });

        this.$scope.$watch(() => this.selectAllAssetCharLovs, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (newValue) {
                    this.filterModel.selectedAssetCharValueIDs = this.assetCharacteristicLovs.map((lov) => lov.characteristicValueID);
                } else {
                    this.filterModel.selectedAssetCharValueIDs = [];
                }
            }
        });

        this.$scope.$watch(() => this.assetSearchModalOpen, (newValue, oldValue) => {
            if (!newValue && newValue != oldValue) {
                if (this.selectedRecIdTitlePairs.length > 0) {
                    var keys = this.selectedRecIdTitlePairs.map((doc) => doc.key);
                    this.UpdateAssetTitles(true);
                }
            }
        });

        this.$scope.$watch(() => this.filterModel.selectedAssetRecordIDs, (newValue, oldValue) => {
            if (newValue != null && newValue.length > 0) {
                this.SetCatalogTitles();
            }
        }, true);

        this.$scope.$watch(() => this.allSelected, (newValue, oldValue) => {
            for (var facetKey in newValue) {
                if (newValue[facetKey]) {
                    this.toggleSelectedAssetFacetValue[facetKey] = false;
                    this.filterModel.selectedAssetFacet[facetKey] = [];
                    var assetFacetValueList = this.assetFacetResults[facetKey];
                    _.forEach(assetFacetValueList, (v) => {
                        this.filterModel.selectedAssetFacet[facetKey].push(v.key);
                    });
                } else {
                    if (!this.toggleSelectedAssetFacetValue[facetKey]) {
                        this.filterModel.selectedAssetFacet[facetKey] = [];
                    }
                }
            }
        }, true);

        this.Init();
    }

    Init() {
        this.notifyService.startProgress();

        // get asset values from search
        var promise1 = this.$q.when();
        var promise2 = this.$q.when();
        var promise3 = this.$q.when();

        if (this.showFacets || this.showFacetSelects) {

            promise1 = this.reportService.getAssetLovTags()
                .then((results) => {
                    this.assetFacetFields = <Models.IDictionaryS<string>>_.extend((<any>results).toJSON(), this.assetFacetFields);
                    return this.reportService.getAssetSearchFacets(_.keys(this.assetFacetFields));
                })
                .then((result) => {
                    this.assetFacetResults = result;
                });

        }

        if (this.showRightTypes || this.showTemplates) {
            promise2 = this.entityConfigService.getCharacteristicTemplates(Consts.CharTypeIDs.right)
                .then((result) => {
                    this.rightSetTemplates = result.filter(t => Utils.AclUtil.hasReadAccess(this.aclService.acls, t.acl));
                    if (this.showRightTypes) {
                        // empty implies all templates
                        this.filterModel.selectedRightSetTemplateIDs = [];
                    }
                });
        }

        if (this.showDimensions) {
            // get empty chardata of this.templateID,  use that for dimension metadata
            promise3 = this.entityConfigService.getRightsDimensions()
                .then((result) => {
                    for (let i = 1; i <= 4; i++) {
                        var characteristic = result.characteristics[i];
                        var lovs = result.lovs[i];
                        if (characteristic != null && lovs != null) {
                            this.dimensions.push({ key: i, value: characteristic.label });

                            switch (i) {
                                case 1:
                                    this.mediaTagLabel = characteristic.tagLabel;
                                    this.mediaCharLabel = characteristic.label;
                                    this.mediaLovs = lovs.listOfValues;
                                    this.mediaGroups = lovs.charValueGroups;
                                    break;
                                case 2:
                                    this.territoryTagLabel = characteristic.tagLabel;
                                    this.territoryCharLabel = characteristic.label;
                                    this.territoryLovs = lovs.listOfValues;
                                    this.territoryGroups = lovs.charValueGroups;
                                    break;
                                case 3:
                                    this.languageTagLabel = characteristic.tagLabel;
                                    this.languageCharLabel = characteristic.label;
                                    this.languageLovs = lovs.listOfValues;
                                    this.languageGroups = lovs.charValueGroups;
                                    break;
                                case 4:
                                    this.channelTagLabel = characteristic.tagLabel;
                                    this.channelCharLabel = characteristic.label;
                                    this.channelLovs = lovs.listOfValues;
                                    this.channelGroups = lovs.charValueGroups;
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                });
        }

        var promise4 = this.$q.when();
        if (this.showAssetChars) {
            promise4 = this.entityConfigService.getCharacteristicList(Consts.CharTypeIDs.property)
                .then((result) => {
                    this.assetCharacteristics = result.filter(ch => ch.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.alphanumeric && ch.charValueSetID != null);
                    this.filterModel.assetCharID = this.assetCharacteristics[0].characteristicID;
                });
        }

        this.$q.all([promise1, promise2, promise3, promise4])
            .then(() => {
                this.filterInitialized = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });

        this.$scope.$watch(() => this.filterModel, (newValue, oldValue) => {
            this.rightsFilterService.SetCachedFilterModel(this.filterModel);
        }, true);

    }


    // when opening the Titles filter, automatically open the search modal if current selection is empty  (skips an extra click)
    TitleClick() {
        if (this.selectedRecIDTitlePairsSorted.length == 0) {
            this.SearchAssets();
        }
    }

    // open search asset modal
    SearchAssets() {
        this.assetSearchModalOpen = true;
    }

    // remove selected asset
    RemoveSearchAsset(assetID: number, $event: ng.IAngularEvent) {
        $event.preventDefault();
        _.remove(this.selectedRecIdTitlePairs, (a) => a.key == assetID);
        this.UpdateAssetTitles(true);
    }

    FormatFacetValue(input: string) {
        return (input || "").split("|")[0];
    }

    FormatFacetValues(input: string[]) {
        return (input || []).map(v => this.FormatFacetValue(v)).join(", ");
    }

    LanguageGroupChanged(group: Models.ICharacteristicValueGroup) {
        var newValueIDs = [];
        if (group != null) {
            newValueIDs = group.charValueAssociations.map(cva => cva.charValueID);
        }
        while (this.filterModel.selectedLanguageIDs.pop()) {

        }
        Array.prototype.splice.apply(this.filterModel.selectedLanguageIDs, [0, 0].concat(newValueIDs));
        this.$scope.$broadcast(Consts.Events.TreeListShowSelected);
    }

    TerritoryGroupChanged(group: Models.ICharacteristicValueGroup) {
        var newValueIDs = [];
        if (group != null) {
            newValueIDs = group.charValueAssociations.map(cva => cva.charValueID);
        }
        while (this.filterModel.selectedTerritoryIDs.pop()) {

        }
        Array.prototype.splice.apply(this.filterModel.selectedTerritoryIDs, [0, 0].concat(newValueIDs));
        this.$scope.$broadcast(Consts.Events.TreeListShowSelected);
    }

    MediaGroupChanged(group: Models.ICharacteristicValueGroup) {
        var newValueIDs = [];
        if (group != null) {
            newValueIDs = group.charValueAssociations.map(cva => cva.charValueID);
        }
        while (this.filterModel.selectedMediaIDs.pop()) {

        }
        Array.prototype.splice.apply(this.filterModel.selectedMediaIDs, [0, 0].concat(newValueIDs));
        this.$scope.$broadcast(Consts.Events.TreeListShowSelected);
    }

    ChannelGroupChanged(group: Models.ICharacteristicValueGroup) {
        var newValueIDs = [];
        if (group != null) {
            newValueIDs = group.charValueAssociations.map(cva => cva.charValueID);
        }
        while (this.filterModel.selectedChannelIDs.pop()) {

        }
        Array.prototype.splice.apply(this.filterModel.selectedChannelIDs, [0, 0].concat(newValueIDs));
        this.$scope.$broadcast(Consts.Events.TreeListShowSelected);
    }

    Search() {
        this.searchMethod();
    }

    Clear() {
        this.selectedRecIdTitlePairs = [];
        this.selectedRecIDTitlePairsSorted = [];
        this.selectedAssetTitles = [];
        this.allSelected = {};

        if (this.rightsFilterService.lastDefaultFilterModel != null) {
            this.filterModel = _.cloneDeep(this.rightsFilterService.lastDefaultFilterModel);

        } else {
            this.filterModel.startDate = "";
            this.filterModel.endDate = "";
            this.filterModel.selectedAssetFacet = {};
            this.filterModel.exclusive = "1";
            this.filterModel.exactInd = "0";
            this.filterModel.isWindowed = false;
            this.filterModel.selectedTemplateID = null;
            this.filterModel.selectedTerritoryLeafIDs = [];
            this.filterModel.selectedMediaLeafIDs = [];
            this.filterModel.selectedChannelLeafIDs = [];
            this.filterModel.selectedLanguageLeafIDs = [];
            this.filterModel.selectedAssetRecordIDs = [];
            this.filterModel.selectedRightSetTemplateIDs = [];
            this.filterModel.selectedTerritoryIDs = [];
            this.filterModel.selectedMediaIDs = [];
            this.filterModel.selectedLanguageIDs = [];
            this.filterModel.selectedChannelIDs = [];
            this.filterModel.selectedTerritoryPaths = [];
            this.filterModel.selectedMediaPaths = [];
            this.filterModel.selectedLanguagePaths = [];
            this.filterModel.selectedChannelPaths = [];
            this.filterModel.minDays = 0;
        }
        if (this.clearMethod != null) {
            this.clearMethod();
        }
    }

    ClearFacet(facetKey: string) {
        this.filterModel.selectedAssetFacet[facetKey] = [];
        this.allSelected[facetKey] = false;
    }

    ClearSelectedAssets() {
        this.selectedRecIdTitlePairs = [];
        this.selectedRecIDTitlePairsSorted = [];
        this.selectedAssetTitles = [];
        this.filterModel.selectedAssetRecordIDs = [];
    }

    ToggleSelectedFacetValue(facetKey: string, value: string) {
        if (this.filterModel.selectedAssetFacet[facetKey] != null) {
            var filterModelSelectedAssetFacetValues = this.filterModel.selectedAssetFacet[facetKey]
            var totalFacetValues = this.assetFacetResults[facetKey];

            if (filterModelSelectedAssetFacetValues.length == totalFacetValues.length) {
                this.allSelected[facetKey] = true;
            }
            else {
                this.allSelected[facetKey] = false;
                this.toggleSelectedAssetFacetValue[facetKey] = true;
            }
        }
    }

    SetCatalogTitles() {
        if (this.filterModel.selectedAssetRecordIDs.length > 0) {
            this.notifyService.startProgress();
            var isRecIDsOrTitles: boolean = true;
            var parentCharTypeID: number = 0;
            var templateID: number = 0;
            var rowBulkIDs: string = "";

            rowBulkIDs = _.map(this.filterModel.selectedAssetRecordIDs, (val) => {
                return val;
            }).join("\r\n");

            this.entityService.validateRecIDsOrTitlesForRelationship(parentCharTypeID, templateID, Consts.CharTypeIDs.property, isRecIDsOrTitles, rowBulkIDs)
                .then((result) => {
                    if (result.success) {
                        var newSelectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[] = [];
                        _.forEach(result.data, (r: Models.IValidateRecIDsOrTitlesResponse) => {
                            var selectedRecIDTitlePair: Models.IKeyValuePair<number, string> = {
                                key: r.recID,
                                value: r.title
                            };
                            newSelectedRecIdTitlePairs.push(selectedRecIDTitlePair);
                        });
                        this.selectedRecIdTitlePairs = newSelectedRecIdTitlePairs;
                    }
                })
                .finally(() => {
                    this.selectedRecIDTitlePairsSorted = _.sortBy(this.selectedRecIdTitlePairs, (doc) => doc.value);
                    this.UpdateAssetTitles(false);
                    this.notifyService.endProgress();
                });
        }
    }

    FormatRollupDimension(dim: number) {
        var dimension = _.find(this.dimensions, kvp => kvp.key == dim);
        if (dimension != null) {
            return dimension.value;
        } else {
            return "";
        }
    }

    UpdateAssetTitles(setFilterModelValues: boolean) {
        this.selectedRecIDTitlePairsSorted = _.sortBy(this.selectedRecIdTitlePairs, (doc) => doc.value);
        this.selectedAssetTitles = this.selectedRecIDTitlePairsSorted.map((doc) => doc.value);
        if (setFilterModelValues) {
            this.filterModel.selectedAssetRecordIDs = this.selectedRecIDTitlePairsSorted.map((doc) => doc.key);
        }
    }
}
